import { render, staticRenderFns } from "./digLtwo.vue?vue&type=template&id=2b977e05&scoped=true"
import script from "./digLtwo.vue?vue&type=script&lang=js"
export * from "./digLtwo.vue?vue&type=script&lang=js"
import style0 from "./digLtwo.vue?vue&type=style&index=0&id=2b977e05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b977e05",
  null
  
)

export default component.exports